import { CALL_API, Schemas } from '../../../common/middleware/api';

export const MASTER_FRANCHISEES_REQUEST = 'MASTER_FRANCHISEES_REQUEST';
export const MASTER_FRANCHISEES_SUCCESS = 'MASTER_FRANCHISEES_SUCCESS';
export const MASTER_FRANCHISEES_FAILURE = 'MASTER_FRANCHISEES_FAILURE';

export const loadMasterFranchisees = (options) => ({
	[CALL_API]: {
		types: [MASTER_FRANCHISEES_REQUEST, MASTER_FRANCHISEES_SUCCESS, MASTER_FRANCHISEES_FAILURE],
		endpoint: 'api/headOffice/masterFranchisees',
		request: options,
		schema: Schemas.MASTER_FRANCHISEE_ARRAY
	}
});